import { useState, useRef } from "react";
import {
  ArrowTrendDown,
  ArrowTrendUp,
  CircleExclamation,
  Minus
} from "@unified-checkout/design-system/icons/index";
import { Tooltip } from "@unified-checkout/design-system";
import { IMetricCard } from "@app/dashboard/types/innerLayout/metric-card";
import { MOBILE_BREAKPOINT } from "@app/dashboard/constants/break-points";
import { useScreenWidth } from "@app/dashboard/hooks/useScreenWidth";
import { getHorizontalPlacement, getVerticalPlacement } from "libs/design-system/src/utils/getPlacement";
import { ComponentError } from "../../../shared/ComponentError";
import styles from "./metric-card.module.scss";

const comparisonIcon = {
  up: ArrowTrendUp,
  down: ArrowTrendDown,
  equal: Minus
};

const MetricCard = (
  {
    title,
    hint,
    amount,
    percentage,
    comparisonText,
    status = 'equal',
    errorText
  }
    :
    IMetricCard
) => {
  const iconRef = useRef<any>();

  const [placement, setPlacement] = useState<any>(`top ${getHorizontalPlacement(iconRef)}`);

  const screenWidth = useScreenWidth();
  const isMobile = screenWidth <= MOBILE_BREAKPOINT;

  const calculateTooltipPlacement = (iconRef: any) => {
    setPlacement(
      isMobile ?
        `${getVerticalPlacement(iconRef)} center`
        :
        `top ${getHorizontalPlacement(iconRef)}`
    );
  };

  return (
    <div className={styles["metric-card"]}>

      {
        errorText ?
          <ComponentError text={errorText} />
          :
          <>
            <div className={styles["metric-card__title-box"]}>
              <span className={styles["metric-card__title-box__title"]}>{title}</span>
              {hint &&
                <Tooltip
                  hintText={hint}
                  centerArrow
                  placement={placement}
                  handleMouseOver={() => calculateTooltipPlacement(iconRef)}
                >
                  <div className={styles["metric-card__title-box__icon"]} ref={iconRef}>{CircleExclamation}</div>
                </Tooltip>
              }
            </div>

            <div className={styles["metric-card__amount"]}>{amount}</div>

            {
              (comparisonText || percentage) &&
              <div className={styles["metric-card__comparison-box"]}>
                {
                  typeof percentage === 'number' &&
                  <span className={styles["metric-card__comparison-box__percentage"]} data-metric-card-status={status}>
                    {comparisonIcon[status]} <span>{` ${percentage}%`}</span>
                  </span>
                }
                {
                  comparisonText &&
                  <span className={styles["metric-card__comparison-box__text"]}>{comparisonText}</span>
                }
              </div>
            }
          </>
      }

    </div>
  )
}

export default MetricCard;